import { render, staticRenderFns } from "./SuperSearch.vue?vue&type=template&id=cba8bb74&scoped=true&"
import script from "./SuperSearch.vue?vue&type=script&lang=js&"
export * from "./SuperSearch.vue?vue&type=script&lang=js&"
import style0 from "./SuperSearch.vue?vue&type=style&index=0&id=cba8bb74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba8bb74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
